// Copyright (c) 2017 Deere & Company

import Pin from '@deere/cps-it.warranty-model-factory/lib/pin';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const resetPin = state =>
    Pin.update(state, {
        $set: getDefaultState().pin
    });

const updateAccount = (state, action) =>
    Pin.update(state, {
        account: {
            $set: action.account
        }
    });

const updateFailureDate = (state, action) =>
    Pin.update(state, {
        failureDate: {
            $set: action.failureDate
        }
    });

const updateInvoiceDate = (state, action) =>
    Pin.update(state, {
        invoiceDate: {
            $set: action.invoiceDate
        }
    });

const updateInvoiceNumber = (state, action) =>
    Pin.update(state, {
        invoiceNumber: {
            $set: action.invoiceNumber
        }
    });

const updatePin = (state, action) =>
    Pin.update(state, {
        pin: {
            $set: action.pin
        }
    });

export default (state = getDefaultState().pin, action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_WEAR_PARTS]: resetPin,
        [actions.RESET_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_PIN]: resetPin,
        [actions.UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_ACCOUNT]: updateAccount,
        [actions.UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_FAILURE_DATE]: updateFailureDate,
        [actions.UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_INVOICE_DATE]: updateInvoiceDate,
        [actions.UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_INVOICE_NUMBER]: updateInvoiceNumber,
        [actions.UPDATE_CLAIM_WEAR_PARTS_CREATE_PIN_MODAL_PIN]: updatePin
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/wear-parts/reducers/pin.js